export default __webpack_public_path__ + "static/media/sphere.9eb54765.svg";